import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Remove external badge
const observer = new MutationObserver(() => {
  const badge = document.getElementById("emergent-badge");
  if (badge) { badge.remove(); observer.disconnect(); }
});
observer.observe(document.body, { childList: true, subtree: true });
